<template>
    <div>
        <h1>{{ $t("admin.adminPolicyCreate.header") }}</h1>
        <form id="search" @submit="createPolicy">
            <label for="name">{{ $t("admin.adminPolicyCreate.policyName") }}: </label><input id="policyName" name="policyName" v-model="policyData.policyName"><br/>
            <label for="policyDescription">{{ $t("admin.adminPolicyCreate.policyDescription") }}: </label><textarea id="policyDescription" name="policyDescription" v-model="policyData.policyDescription"></textarea><br/>

        <table class="datatable">
            <caption class="caption">Policy detail table</caption>
            <tr>
                <th scope="col">{{ $t("admin.adminPolicyCreate.table.module") }}</th>
                <th scope="col">{{ $t("admin.adminPolicyCreate.table.function") }}</th>
            </tr>
            <tr v-for="(func, index) in functionList" v-bind:key="index">
                <td v-if="index == 0">
                    <label><input id="moduleEnabled" name="moduleEnabled" v-model="policyData.moduleEnabled[func.moduleId]" type="checkbox">{{ func.moduleName }}</label>
                </td>
                <td v-else-if="!(func.moduleId == functionList[index - 1].moduleId)">
                    <label><input id="moduleEnabled" name="moduleEnabled" v-model="policyData.moduleEnabled[func.moduleId]" type="checkbox">{{ func.moduleName }}</label>
                </td>
                <td v-else>
                </td>
                <td>
                    <label><input id="functionEnabled" name="functionEnabled" v-model="policyData.functionEnabled[func.functionId]" type="checkbox">{{ func.functionName }}</label>
                </td>
            </tr>

        </table>

            <input type="submit" class="submit" v-bind:value="$t('admin.adminPolicyCreate.button.create')">
        </form>
        <AdminPolicyDelete v-bind:policy="policyData" />
    </div>
</template>

<script>
    import {adminService} from '@/services/admin.service'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/locale/ja';

    export default {
        name: 'AdminPolicyCreate',
        components: {
            DatePicker
        },
        data: function () {
            return {
                policyData: {
                    planId: 0,
                    moduleEnabled: {},
                    functionEnabled: {}
                },
                functionList: [],
                functionEnabled: []
            };
        },
        created: function() {
            this.listFunction();
        },
        methods: {
            listFunction: function () {
                adminService.functionList().then((data) => {
                    this.functionList = data;

                }).catch((err) => {
                    console.error('Unable to get function list', err)
                })
            },
            createPolicy: function (e) {
                e.preventDefault();
                let tmpPolicyData = JSON.parse(JSON.stringify(this.policyData));
                tmpPolicyData.policyDescription = btoa(encodeURIComponent(this.policyData.policyDescription))
                
                adminService.policyCreate(tmpPolicyData).then((policy) => {
                    console.log('Policy Created: ', policy);

                    let createdPolicyId = policy[0].policyId
                    this.$router.push('/admin/policyView/' + createdPolicyId);
                }).catch((err) => {
                    console.error('Unable to create policy: ', err)
                })
            }
        }
    }
</script>
